import { cn } from "@/lib/utils/cn"

/**
 * 签名视觉：网格草稿纸 + 小智批注（Annotation Language）。
 * 印刷黑题干 / 学生蓝作答 / 小智橙楷体旁批 —— 三墨水模型。
 */
export function PaperDemo({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "paper-surface rounded-lg border border-hairline p-6 rotate-1",
        className
      )}
    >
      {/* 纸面页眉：元信息只出现在纸面边缘 */}
      <div className="flex items-center justify-between text-caption text-ink-soft">
        <span>错题本 · 数学</span>
        <span>今天</span>
      </div>

      {/* 题干：印刷黑 */}
      <p className="mt-6 text-body font-medium text-ink">
        解方程：3x + 5 = 2x − 4
      </p>

      {/* 学生作答：学生蓝 */}
      <p className="mt-6 text-caption text-ink-soft">你的作答</p>
      <div className="mt-2 space-y-2 text-body text-primary">
        <p>
          3x − 2x = −4{" "}
          <span className="underline decoration-wavy decoration-annotation underline-offset-4">
            + 5
          </span>
        </p>
        <p>x = 1</p>
      </div>

      {/* 小智旁批：批注橙竖线锚定 + 楷体笔迹 */}
      <div className="mt-6 border-l-2 border-annotation pl-3">
        <p className="font-note text-annotation">
          移项要变号——+5 移到右边，应该变成 −5。
        </p>
        <p className="font-note text-annotation">
          正确答案：x = −9。再算一次试试？
        </p>
      </div>
    </div>
  )
}
